<template>
  <div class="preview-header" :style="fisherStyle">
    <a-dropdown :trigger="['click']" :disabled="isFisher">
      <a-button class="back" icon="menu" />
      <a-menu
        slot="overlay"
        class="timeline-filter-menu header-menu"
        @click="handleMenuClick"
        style="margin: -7px 5px"
      >
        <a-menu-item key="new">
          <a-icon :component="icons.new" />
          新建空白设计
        </a-menu-item>
        <a-menu-item key="copy" v-if="!templateId" :disabled="readonly">
          <a-icon :component="icons.copy" />
          复制当前草稿
        </a-menu-item>
        <a-menu-item key="drafts">
          <a-icon :component="icons.drafts" />
          查看我的草稿
        </a-menu-item>
        <a-menu-item key="backup">
          <a-icon type="folder-open" />
          查看备份数据
        </a-menu-item>
        <a-menu-item key="keyboard">
          <a-icon :component="icons.keyboard" />
          键盘快捷方式
        </a-menu-item>
        <a-menu-item key="advanced">
          <a-icon type="setting" />
          高级设置
        </a-menu-item>
        <a-menu-item>
          <a href="/lists">
            <a-icon :component="icons.back" />
            返回我的视频
          </a>
        </a-menu-item>
      </a-menu>
    </a-dropdown>
    <div class="header-button-group-wrap">
      <div class="header-button-group">
        <div class="seo-menu" v-show="showSeoMenu">
          <div class="seo-menu-title">
            <div class="seo-title">推荐</div>
            <div class="seo-search">搜索量</div>
            <div class="seo-hard">SEO难度</div>
          </div>
          <a-spin :spinning="loading" class="seo-menu__spin">
            <div
              :key="item.title"
              @click="handleSelect(item.title)"
              class="seo-item"
              v-for="item in seoList"
            >
              <div class="seo-title">
                <template v-for="(match, i) in item.title.split(item.ass_wd)"
                  ><b class="red" v-if="i" :key="i">{{ item.ass_wd }}</b
                  >{{ match }}</template
                >
              </div>
              <div class="seo-search">{{ item.vol }}</div>
              <div class="seo-hard">{{ item.sd }}</div>
            </div>
            <div class="seo-item" v-if="!seoList.length" />
          </a-spin>
        </div>
        <el-tooltip content="撤销 (Ctrl+Z)">
          <button
            type="button"
            @click="undo"
            :disabled="!canUndo"
            class="icon iconfont"
          >
            &#xe644;
          </button>
        </el-tooltip>
        <el-tooltip content="恢复 (Ctrl+Y)">
          <button
            type="button"
            @click="redo"
            :disabled="!canRedo"
            class="icon iconfont"
          >
            &#xe646;
          </button>
        </el-tooltip>
        <div class="header-button-group__divider"></div>
        <el-tooltip content="缩小">
          <button
            type="button"
            @click="zoomOut"
            :disabled="playerScale <= 50"
            class="icon iconfont"
          >
            &#xe645;
          </button>
        </el-tooltip>
        <span class="header-button-group__text">{{ playerScale }}%</span>
        <el-tooltip content="放大">
          <button
            type="button"
            @click="zoomIn"
            :disabled="playerScale >= 200"
            class="icon iconfont"
          >
            &#xe643;
          </button>
        </el-tooltip>
        <!-- <button type="button" disabled class="icon iconfont">&#xe647;</button> -->
        <el-tooltip content="原始大小">
          <button type="button" @click="resetZoom" class="icon iconfont">
            &#xe641;
          </button>
        </el-tooltip>
        <div class="header-button-group__divider"></div>
        <input
          class="preview-header-title"
          placeholder="请输入视频名称"
          v-model="videoName"
          @blur="onBlur"
        />
        <a-icon class="pen" type="edit" />
      </div>
    </div>
    <div class="header-draft-generate">
      <span class="header-total-duration">总时长: {{ totalDuration }}</span>
      <el-tooltip content="夜间模式" v-if="!isDark">
        <div class="icon fill-icon" @click="inDark">
          <img src="/preview/icon/dark.png" alt="" />
        </div>
      </el-tooltip>
      <el-tooltip content="白天模式" v-else>
        <div class="icon" @click="offDark">
          <img src="/preview/icon/light.png" alt="" />
        </div>
      </el-tooltip>
      <el-tooltip content="全屏模式" v-if="!isFullScreen">
        <div :class="{ 'fill-icon': !isDark }" class="icon" @click="fullScreen">
          <img src="/preview/icon/screen-on.png" alt="" />
        </div>
      </el-tooltip>
      <el-tooltip content="退出全屏模式" v-else>
        <div
          :class="{ 'fill-icon': !isDark }"
          class="icon"
          @click="exitFullScreen"
        >
          <img src="/preview/icon/screen-off.png" alt="" />
        </div>
      </el-tooltip>
      <el-tooltip content="编辑器切换">
        <a-icon
          v-if="!isFisher"
          type="swap"
          class="icon"
          :class="{ 'fill-icon': !isDark }"
          @click="switchEditor"
        />
      </el-tooltip>
      <!-- <a class="helps" href="/help?nav=4&cat_id=24" target="_blank">帮助</a> -->
      <button
        type="button"
        class="header-button save-button"
        @click="handlePreview"
      >
        <img src="/preview/icon/video.png" class="icon" />
        预览
      </button>
      <button
        type="button"
        @click="saveVideoTemplate"
        class="header-button save-button"
        v-if="templateId"
      >
        <span class="icon iconfont">&#xe64f;</span>
        保存模板
      </button>
      <template v-else>
        <button
          v-if="!isFisher"
          type="button"
          @click="saveDraft"
          class="header-button save-button"
          :disabled="readonly"
        >
          <img src="/preview/icon/save.png" class="icon" />
          保存草稿
        </button>
        <button
          type="button"
          @click="handleCreate"
          class="header-button generate-button"
          :disabled="readonly"
        >
          <span class="icon iconfont">&#xe64e;</span>
          生成视频
        </button>
      </template>
    </div>
    <preview-poster @submit="updateVideo">
        <span class="red">{{productionVideoTips?'(素材视频正在转换中)':''}}</span>
    </preview-poster>
    <a-modal v-model="showAdvanced" title="高级设置" @ok="handleAdvancedOK">
      <template v-if="backupSettings">
        <a-row
          type="flex"
          align="middle"
          class="advanced-settings-row"
          :gutter="8"
        >
          <a-col flex="1">
            <a-checkbox v-model="backupSettings.is_set_save">
              自动保存时间间隔
            </a-checkbox>
          </a-col>
          <a-col>
            <a-select
              class="advanced-settings-select"
              v-model="backupSettings.auto_save_minutes"
            >
              <a-select-option
                v-for="v in autoSaveIntervals"
                :key="v"
                :value="v"
              >
                {{ v }}
              </a-select-option>
            </a-select>
          </a-col>
          <a-col>分钟</a-col>
        </a-row>
        <a-row
          type="flex"
          align="middle"
          class="advanced-settings-row"
          :gutter="8"
        >
          <a-col flex="1">
            <a-checkbox v-model="backupSettings.is_set_backup">
              自动备份时间间隔
            </a-checkbox>
          </a-col>
          <a-col>
            <a-select
              class="advanced-settings-select"
              v-model="backupSettings.auto_backup_minutes"
            >
              <a-select-option
                v-for="v in autoSaveIntervals"
                :key="v"
                :value="v"
              >
                {{ v }}
              </a-select-option>
            </a-select>
          </a-col>
          <a-col>分钟</a-col>
        </a-row>
        <a-row type="flex">
          <div>提示：</div>
          <div>
            <div>1.系统自动备份只有1份，超出将自动清除并替换早前记录。</div>
            <div>2.备份数据最多保留7天，逾期系统将自动清除。</div>
          </div>
        </a-row>
      </template>
    </a-modal>
  </div>
</template>

<script>
import { message, Modal } from 'ant-design-vue';
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex'
import { fakeFunction } from '../../utils/util';
import { clamp, formatTimeInterval } from '../../utils';
import PreviewPoster from '../player/PreviewPoster';
import { get, post } from '../../utils/api';

const MenuIcons = {
  new: {
    render() {
      return this.$createElement('svg',
        { attrs: { viewBox: '0 0 16 16' } },
        [
          this.$createElement('path', {
            attrs: { d: 'M13.353125,4.509375 L9.990625,1.146875 C9.896875,1.053125 9.7703125,1 9.6375,1 L3,1 C2.7234375,1 2.5,1.2234375 2.5,1.5 L2.5,14.5 C2.5,14.7765625 2.7234375,15 3,15 L13,15 C13.2765625,15 13.5,14.7765625 13.5,14.5 L13.5,4.8640625 C13.5,4.73125 13.446875,4.603125 13.353125,4.509375 Z M12.346875,5.09375 L9.40625,5.09375 L9.40625,2.153125 L12.346875,5.09375 Z M12.375,13.875 L3.625,13.875 L3.625,2.125 L8.34375,2.125 L8.34375,5.5 C8.34375,5.8625 8.6375,6.15625 9,6.15625 L12.375,6.15625 L12.375,13.875 Z' }
          })
        ]);
    }
  },
  copy: {
    render() {
      return this.$createElement('svg',
        { attrs: { viewBox: '0 0 16 16' } },
        [
          this.$createElement('path', {
            attrs: { d: 'M13,1 L4.625,1 C4.55625,1 4.5,1.05625 4.5,1.125 L4.5,2 C4.5,2.06875 4.55625,2.125 4.625,2.125 L12.375,2.125 L12.375,12.875 C12.375,12.94375 12.43125,13 12.5,13 L13.375,13 C13.44375,13 13.5,12.94375 13.5,12.875 L13.5,1.5 C13.5,1.2234375 13.2765625,1 13,1 Z M11,3 L3,3 C2.7234375,3 2.5,3.2234375 2.5,3.5 L2.5,11.7921875 C2.5,11.925 2.553125,12.0515625 2.646875,12.1453125 L5.3546875,14.853125 C5.3890625,14.8875 5.428125,14.915625 5.4703125,14.9390625 L5.4703125,14.96875 L5.5359375,14.96875 C5.590625,14.9890625 5.6484375,15 5.7078125,15 L11,15 C11.2765625,15 11.5,14.7765625 11.5,14.5 L11.5,3.5 C11.5,3.2234375 11.2765625,3 11,3 Z M5.46875,13.378125 L4.1234375,12.03125 L5.46875,12.03125 L5.46875,13.378125 Z M10.375,13.875 L6.46875,13.875 L6.46875,11.65625 C6.46875,11.3109375 6.1890625,11.03125 5.84375,11.03125 L3.625,11.03125 L3.625,4.125 L10.375,4.125 L10.375,13.875 Z' }
          })
        ]);
    }
  },
  drafts: {
    render() {
      return this.$createElement('svg',
        { attrs: { viewBox: '0 0 16 16' } },
        [
          this.$createElement('path', {
            attrs: { d: 'M10.75,4.875 L10.75,4.125 C10.75,4.05625 10.69375,4 10.625,4 L4.625,4 C4.55625,4 4.5,4.05625 4.5,4.125 L4.5,4.875 C4.5,4.94375 4.55625,5 4.625,5 L10.625,5 C10.69375,5 10.75,4.94375 10.75,4.875 Z M4.625,6.25 C4.55625,6.25 4.5,6.30625 4.5,6.375 L4.5,7.125 C4.5,7.19375 4.55625,7.25 4.625,7.25 L7.5,7.25 C7.56875,7.25 7.625,7.19375 7.625,7.125 L7.625,6.375 C7.625,6.30625 7.56875,6.25 7.5,6.25 L4.625,6.25 Z M6.875,13.3125 L3.25,13.3125 L3.25,2.3125 L12,2.3125 L12,7.6875 C12,7.75625 12.05625,7.8125 12.125,7.8125 L13,7.8125 C13.06875,7.8125 13.125,7.75625 13.125,7.6875 L13.125,1.6875 C13.125,1.4109375 12.9015625,1.1875 12.625,1.1875 L2.625,1.1875 C2.3484375,1.1875 2.125,1.4109375 2.125,1.6875 L2.125,13.9375 C2.125,14.2140625 2.3484375,14.4375 2.625,14.4375 L6.875,14.4375 C6.94375,14.4375 7,14.38125 7,14.3125 L7,13.4375 C7,13.36875 6.94375,13.3125 6.875,13.3125 Z M13.8390625,14.1171875 L12.38125,12.659375 C12.7296875,12.1984375 12.9375,11.6234375 12.9375,11 C12.9375,9.48125 11.70625,8.25 10.1875,8.25 C8.66875,8.25 7.4375,9.48125 7.4375,11 C7.4375,12.51875 8.66875,13.75 10.1875,13.75 C10.746875,13.75 11.265625,13.5828125 11.7,13.296875 L13.1796875,14.7765625 C13.2046875,14.8015625 13.2359375,14.8125 13.2671875,14.8125 C13.2984375,14.8125 13.33125,14.8 13.3546875,14.7765625 L13.8390625,14.2921875 C13.8875,14.24375 13.8875,14.165625 13.8390625,14.1171875 Z M10.1875,12.75 C9.2203125,12.75 8.4375,11.9671875 8.4375,11 C8.4375,10.0328125 9.2203125,9.25 10.1875,9.25 C11.1546875,9.25 11.9375,10.0328125 11.9375,11 C11.9375,11.9671875 11.1546875,12.75 10.1875,12.75 Z' }
          })
        ]);
    }
  },
  keyboard: {
    render() {
      return this.$createElement('svg',
        { attrs: { viewBox: '0 0 16 16' } },
        [
          this.$createElement('path', {
            attrs: { d: 'M5.34375,7.375 L10.6875,7.375 C10.69375,7.375 10.7015625,7.375 10.7078125,7.3734375 C10.7765625,7.3625 10.821875,7.2984375 10.8109375,7.2296875 L10.1828125,3.3546875 C10.1734375,3.29375 10.1203125,3.25 10.059375,3.25 L5.971875,3.25 C5.9109375,3.25 5.8578125,3.29375 5.8484375,3.3546875 L5.2203125,7.2296875 C5.21875,7.2359375 5.21875,7.24375 5.21875,7.25 C5.21875,7.31875 5.275,7.375 5.34375,7.375 Z M6.76875,4.3125 L9.2609375,4.3125 L9.584375,6.3125 L6.44375,6.3125 L6.76875,4.3125 L6.76875,4.3125 Z M6.8078125,8.7296875 C6.7984375,8.66875 6.7453125,8.625 6.684375,8.625 L2.596875,8.625 C2.5359375,8.625 2.4828125,8.66875 2.4734375,8.7296875 L1.8453125,12.6046875 C1.84375,12.6109375 1.84375,12.61875 1.84375,12.625 C1.84375,12.69375 1.9,12.75 1.96875,12.75 L7.3125,12.75 C7.31875,12.75 7.3265625,12.75 7.3328125,12.7484375 C7.4015625,12.7375 7.446875,12.6734375 7.4359375,12.6046875 L6.8078125,8.7296875 L6.8078125,8.7296875 Z M3.0703125,11.6875 L3.39375,9.6875 L5.8859375,9.6875 L6.209375,11.6875 L3.0703125,11.6875 Z M14.1546875,12.6046875 L13.5265625,8.7296875 C13.5171875,8.66875 13.4640625,8.625 13.403125,8.625 L9.315625,8.625 C9.2546875,8.625 9.2015625,8.66875 9.1921875,8.7296875 L8.5640625,12.6046875 C8.5625,12.6109375 8.5625,12.61875 8.5625,12.625 C8.5625,12.69375 8.61875,12.75 8.6875,12.75 L14.03125,12.75 C14.0375,12.75 14.0453125,12.75 14.0515625,12.7484375 C14.11875,12.7375 14.165625,12.6734375 14.1546875,12.6046875 L14.1546875,12.6046875 Z M9.7890625,11.6875 L10.1125,9.6875 L12.6046875,9.6875 L12.928125,11.6875 L9.7890625,11.6875 Z' }
          })
        ]);
    }
  },
  back: {
    render() {
      return this.$createElement('svg',
        { attrs: { viewBox: '0 0 16 16' } },
        [
          this.$createElement('path', {
            attrs: { d: 'M12.390625,3.78125 L5.71875,3.78125 L5.71875,2.625 C5.71875,2.5203125 5.5984375,2.4625 5.5171875,2.5265625 L3.2984375,4.2765625 C3.234375,4.3265625 3.234375,4.4234375 3.2984375,4.4734375 L5.5171875,6.2234375 C5.5984375,6.2875 5.71875,6.2296875 5.71875,6.125 L5.71875,4.96875 L12.203125,4.96875 L12.203125,12.3125 L2.734375,12.3125 C2.665625,12.3125 2.609375,12.36875 2.609375,12.4375 L2.609375,13.375 C2.609375,13.44375 2.665625,13.5 2.734375,13.5 L12.390625,13.5 C12.9421875,13.5 13.390625,13.0515625 13.390625,12.5 L13.390625,4.78125 C13.390625,4.2296875 12.9421875,3.78125 12.390625,3.78125 Z' }
          })
        ]);
    }
  }
};

export default {
  name: "Header",
  components: { PreviewPoster },
  data() {
    return {
      showSeoMenu: false,
      loading: false,
      isFullScreen: false,
      icons: MenuIcons,
      showAdvanced: false,
      backupSettings: null,
      autoSaveIntervals: [2, 5, 10]
    };
  },
  mounted() {
    // esc退出全屏
    document.addEventListener("fullscreenchange", () => {
      this.isFullScreen = !this.isFullScreen;
    });
    document.addEventListener("mozfullscreenchange", () => {
      this.isFullScreen = !this.isFullScreen;
    });
    document.addEventListener("webkitfullscreenchange", () => {
      this.isFullScreen = !this.isFullScreen;
    });
    document.addEventListener("msfullscreenchange", () => {
      this.isFullScreen = !this.isFullScreen;
    });
    // F11全屏、退出全屏
    document.addEventListener('keydown', (e) => {
      if (e.keyCode == 27 && this.isFullScreen) {
        e.preventDefault()
        this.exitFullScreen()
      }
      if (e.keyCode == 122) {
        e.preventDefault()
        this.isFullScreen ? this.exitFullScreen() : this.fullScreen()
      }
    });
    if (window.screen.width <= 1366) {
      this.handlePlayerScale(80);
    } else if (window.screen.width <= 1440) {
      this.handlePlayerScale(90);
    }
  },
  methods: {
    ...mapActions(['getUserbasics', 'login', 'updateVideo', 'getEditCount', 'getSeoTitle', 'saveVideoTemplate', 'undo', 'redo']),
    ...mapMutations(['handleVideoName', 'handlePlayerScale', 'handleUserBasics']),
    handleSelect(name) {
      this.handleVideoName(name);
      this.showSeoMenu = false;
    },
    async handleCreate() {
      if (!this.lock) {
        this.lock = true;
        await this.processCreate();
        this.lock = false;
      }
    },
    async processCreate() {
      let content = [];
      const count = this.availableCount;
      let consume = 0;

      if (Object.keys(this.intersectingTracks).length) {
        Modal.error({
          title: '检测到重叠的字幕',
          content: '系统暂不支持字幕重叠，请检查字幕时间轴上是否有红色重叠提示并更正。'
        });
        return;
      }
      if (Object.keys(this.intersectingCustomTTS).length) {
        Modal.error({
          title: '检测到重叠的自定义字幕配音',
          content: '系统暂不支持字幕重叠，请检查字幕时间轴上是否有红色重叠提示并更正。'
        });
        return;
      }
      // 带有id的视频为编辑，跳过配额检测
      if (this.id) {
        let editTotal = this.editTotal;
        const data = await this.getEditCount(editTotal);
        const obj = {
          current: -1,
          url: ''
        };
        if (data.ms_cover >= 0) {
          obj.current = +data.ms_cover;
        } else {
          obj.url = data.text && data.text.cutThumbnail || data.thumbnail;
        }
        this.$store.commit('handlePosterMetadata', obj);

        if (data.again_num == 0) {
          content.push(`视频只允许编辑修改${editTotal}次，确认生成后，将会扣除一次修改权限`);
        } else if (data.again_num == editTotal - 1) {
          content.push(`视频只允许编辑修改${editTotal}次，您已修改了${data.again_num}次，确认生成后，您的视频编辑修改权限将用完`);
        } else {
          content.push(`视频只允许编辑修改${editTotal}次，您已修改了${data.again_num}次，确认生成后，您还剩下${editTotal - data.again_num - 1}次编辑修改权限`);
        }

        if (data.text && data.text.wordParams && typeof data.text.wordParams === 'object') {
          this.$store.commit('handleCoverParams', data.text.wordParams);
          this.$store.commit('handleCoverWatermark', !!data.text.hasStamp);
        }

        // if (data.translated === 2) {
        //   const usedLanguages = { 'en-GB-Wavenet-A': true };
        //   const subtitleArr = data.subtitle || [];
        //   subtitleArr.forEach(lang => {
        //     usedLanguages[lang] = true;
        //   });
        //   consume = this.selectedLanguages.filter(lang => {
        //     const langObj = this.languageLookup[lang];
        //     if (langObj) {
        //       return !(langObj.subtitle in usedLanguages);
        //     }
        //     return false;
        //   }).length;
        // } else if (data.translated === 1) {
        //   consume = this.selectedLanguages.length;
        // }
      } else {
        // consume = this.translationEnabled ? this.selectedLanguages.length + 1 : 1;
        consume = 1
      }
      if (consume) {
        if (count - consume < 0) {
          Modal.error({
            title: '无可用视频配额',
            content: '您的视频配额不足，如需继续创建请联系客服! 温馨提示：生成失败的视频也占用视频配额数，您可以删除生成失败的视频以恢复可用配额。'
          });
          return;
        }
        content.push(`确认生成将扣除套餐配额 1 个，剩余可用配额 ${count - 1} 个`);
      }
      this.$store.commit('handlePosterTitle', {
        title: '生成视频',
        tips: content
      });
      this.$store.commit('handlePosterVisible', true);
    },
    inDark() {
      this.saveDark(true);
    },
    offDark() {
      this.saveDark(false);
    },
    saveDark(value) {
      const valueColor = value ? '#000' : '#fff';
      this.handleUserBasics({
        ...this.userBasics,
        color: valueColor
      });

      return post('user/upcolor', {
        color: valueColor
      });
    },
    fullScreen() {
      var docElm = document.documentElement;
      if (docElm.requestFullscreen) { //W3C
        docElm.requestFullscreen();
      } else if (docElm.mozRequestFullScreen) { //FireFox
        docElm.mozRequestFullScreen();
      } else if (docElm.webkitRequestFullScreen) { //Chrome等
        docElm.webkitRequestFullScreen();
      } else if (docElm.msRequestFullscreen) { //IE11
        docElm.msRequestFullscreen();
      }
    },
    exitFullScreen() {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.webkitCancelFullScreen) {
        document.webkitCancelFullScreen();
      } else if (document.msExitFullscreen) {
        document.msExitFullscreen();
      }
    },
    handlePreview() {
      // await this.$store.dispatch('loadTranslations', true); subtitle is not displayed here
      this.$store.commit('handlePreviewVisible', true);
    },
    onBlur() {
      this.blurTimer = setTimeout(() => {
        this.blurTimer = null;
        this.showSeoMenu = false;
        this.loading = false;
      }, 500);
    },
    // goBack() {
    //   window.history.back();
    // },
    saveDraft() {
      return this.$store.dispatch('saveDraftNotify');
    },
    async copyDraft() {
      const done = await new Promise(resolve => {
        Modal.confirm({
          title: '确定复制当前草稿?',
          content: '当前草稿将被保存，并创建一个副本。',
          onOk: () => {
            resolve(true);
          },
          onCancel() {
            resolve(false);
          }
        });
      });
      if (done) {
        const saved = await this.$store.dispatch('saveDraft');
        if (saved) {
          const { draftId } = this.$store.state;
          const { draft_id } = await post('video-draft/copy', { id: draftId });
          Modal.confirm({
            title: '草稿复制成功',
            content: '可在新标签页打开被复制的草稿。',
            onOk() {
              window.open(`/timelinepreview?draftid=${draft_id}`, '_blank');
            }
          });
        }
      }
    },
    zoomIn() {
      this.handlePlayerScale(clamp(this.playerScale + 10, 50, 200));
    },
    zoomOut() {
      this.handlePlayerScale(clamp(this.playerScale - 10, 50, 200));
    },
    resetZoom() {
      this.handlePlayerScale(100);
    },
    handleMenuClick({ key }) {
      switch (key) {
        case 'new':
          window.open('/timelinepreview', '_blank');
          break;
        case 'copy':
          this.copyDraft();
          break;
        case 'drafts':
          window.open('/setting?nav=3', '_blank');
          break;
        case 'backup':
          this.openBackup();
          break;
        case 'templates':
          window.open('/modellist', '_blank');
          break;
        case 'keyboard':
          this.$store.commit('handleKeyboardShortcutShow', true);
          break;
        case 'advanced':
          this.openAdvanced();
          break;
      }
    },
    async openBackup() {
      const data = await get('user/basics');
      if (!data.has_backup) {
        Modal.warning({
          title: '提示',
          width: '540px',
          zIndex: 999,
          content: h => [
            h('p', {}, '暂没有自动备份数据！'),
            h('p', {
              style: { margin: 0 }
            }, '提示: 没有备份数据可检查以下两点:'),
            h('ol', {}, [
              h('li', {}, '备份数据已超过 7 天保留期，系统已自动清除;'),
              h('li', {}, [
                '尚未开启使用自动备份功能，请打开【',
                h('a', {
                  attrs: { href: '#' },
                  on: {
                    click: e => {
                      e.preventDefault();
                      this.openAdvanced();
                    }
                  }
                }, '高级设置'),
                '】启用。'
              ])
            ])
          ]
        });
      } else {
        window.open('/timelinepreview?backup=1', '_blank');
      }
    },
    openAdvanced() {
      this.showAdvanced = true;
      const { backup_setting } = this.userBasics;
      this.backupSettings = {
        ...backup_setting,
        auto_save_minutes: backup_setting.auto_save_minutes || 5,
        auto_backup_minutes: backup_setting.auto_backup_minutes || 5
      };
    },
    async handleAdvancedOK() {
      await post('video/save_advance_setting', this.backupSettings);

      this.handleUserBasics({
        ...this.userBasics,
        backup_setting: this.backupSettings
      });

      this.showAdvanced = false;
    },
    async processAutoSave() {
      this.nextAutoSave = null;

      if (this.autoSaveMarker) {
        if (this.id || this.draftId) {
          await this.$store.dispatch('saveDraft');
          message.info('自动保存成功！');
        } else {
          console.log('backup')
          await this.$store.dispatch('saveBackup');
        }
      }
      if (this.autoSaveMarker) {
        this.nextAutoSave = setTimeout(this.processAutoSave, this.usedAutoSaveInterval);
      }
    },
    async lockSeoTitle(value) {
      if (!value) {
        if (this.seoTitleLock) {
          clearTimeout(this.seoTitleLock);
          this.seoTitleLock = false;
        }
        return;
      }
      const processTitle = () => {
        this.getSeoTitle(value).then((done) => {
          if (done) {
            console.log(value);
            this.loading = false;
          } else {
            console.log('mismatch: ' + value);
          }
        });
      };
      if (this.seoTitleLock) {
        this.processGetSeoTitle = processTitle;
        clearTimeout(this.seoTitleLock);
      } else {
        processTitle();
      }

      this.loading = true;
      this.seoTitleLock = setTimeout(() => {
        this.seoTitleLock = false;
        if (this.processGetSeoTitle) {
          this.processGetSeoTitle();
          this.processGetSeoTitle = null;
        }
      }, 400);
    },
    async switchEditor() {
      const done = await new Promise(resolve => {
        Modal.confirm({
          title: '编辑器切换',
          content: this.readonly ? '对当前内容的更改将会被丢失。' : '当前内容将被保存为草稿，并在快速编辑器打开。',
          onOk: () => {
            resolve(true);
          },
          onCancel() {
            resolve(false);
          }
        });
      });
      if (done) {
        const saved = this.readonly ? true : await this.$store.dispatch('saveDraft');
        if (saved) {
          const { id, draftId } = this.$store.state;
          window.onbeforeunload = null;
          let query = '';
          if (draftId) {
            query = '?draftid=' + draftId;
          } else if (id) {
            query = '?id=' + id;
          }
          if (this.readonly) {
            query += (query ? '&' : '?') + 'readonly=1';
          }
          location.href = '/editor' + query;
        }
      }
    },
    fakeFunction
  },
  computed: {
    ...mapState([
      'isFisher',
      'fisherInfo',
      'translationEnabled',
      'selectedLanguages',
      'id',
      'draftId',
      'seoTitleList',
      'seoTitleListKeyData',
      'templateId',
      'backUrl',
      'undoStack',
      'undoPos',
      'playerScale',
      'userMeal',
      'userBasics',
      'languageLookup',
      'subtitleTracks',
      'posterVisible',
      'readonly',
      'effects'
    ]),
    ...mapGetters(['seoList', 'intersectingTracks', 'intersectingCustomTTS']),
    videoName: {
      get() {
        return this.$store.state.videoName;
      },
      set(value) {
        this.showSeoMenu = value !== '';
        this.lockSeoTitle(value);
        this.handleVideoName(value);
      }
    },
    productionVideoTips(){
      var loading = false;
      var _t =this;
      Object.keys(_t.effects).map(a=>{
        if(_t.effects[a].shakinessId){
          loading = true;
        }
      })
      return loading;
    },
    canUndo() {
      return !!this.undoStack[this.undoPos - 1];
    },
    canRedo() {
      return !!this.undoStack[this.undoPos + 1];
    },
    totalDuration() {
      const value = this.$store.getters.totalDuration;
      return formatTimeInterval(value);
    },
    editTotal() {
      if (this.userMeal) {
        return this.userMeal[11].value ? +this.userMeal[11].value : 0;
      }
      return 0;
    },
    availableCount() {
      const userBasics = this.userBasics;
      if (!userBasics) return 0;
      const isDigitalHumanFisher = this.isFisher && this.fisherInfo?.type === 'digitalHuman';
      return isDigitalHumanFisher ? userBasics.digital_people_quantity : userBasics.can_count;
    },
    isDark() {
      if (this.userBasics) {
        const { color } = this.userBasics;
        return color === '#000';
      }
      return false;
    },
    autoSaveMarker() {
      if (this.templateId) {
        return false;
      }
      if (this.posterVisible) {
        console.log('displaying poster.');
        return false;
      }
      if (this.undoStack.length > 1 && this.userBasics) {
        const { backup_setting } = this.userBasics;
        return this.id || this.draftId
          ? backup_setting.is_set_save : backup_setting.is_set_backup;
      }

      return false;
    },
    usedAutoSaveInterval() {
      if (this.autoSaveMarker) {
        const { backup_setting } = this.userBasics;
        return (
          this.id || this.draftId ? backup_setting.auto_save_minutes : backup_setting.auto_backup_minutes
        ) * 6e4; // minutes to milliseconds
      }

      return -1;
    },
    fisherStyle() {
      if (this.isFisher) {
        return {
          'background-image': 'url(/assets/imgs/setting/lifisher_logo_img.svg)'
        }
      }
      return {}
    }
  },
  beforeMount() {
    this.login();
  },
  beforeDestroy() {
    this.blurTimer && clearTimeout(this.blurTimer);
    this.nextAutoSave && clearTimeout(this.nextAutoSave);
    this.seoTitleLock && clearTimeout(this.seoTitleLock);
  },
  watch: {
    isDark(val) {
      document.querySelector('link[title="dark"]').disabled = val;
      document.querySelector('link[title="dark"]').disabled = !val;
    },
    autoSaveMarker(val) {
      if (val) {
        if (!this.nextAutoSave) {
          this.nextAutoSave = setTimeout(this.processAutoSave, 5e3); // wait for 5s before first autosave
        }
      } else if (this.nextAutoSave) {
        clearTimeout(this.nextAutoSave);
        this.nextAutoSave = null;
      }
    }
  }
}
</script>

<style scoped>
.preview-header,
.header-draft-generate,
.header-button {
  display: flex;
  align-items: center;
}

.preview-header {
  background: #fff url("/assets/imgs/setting/video_setting_logo.png") 84px
    calc(50% + 1px) no-repeat;
  background-size: 100px;
  width: 100%;
  height: 50px;
  margin: 0 auto;
  min-width: 1366px;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 100;
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.06), 0 0 6px rgba(0, 0, 0, 0.1);
}

.preview-header .back {
  width: 60px;
  height: 50px;
  /*background: rgba(0, 0, 0, 0.1);*/
  background: #202d3d;
  color: #ffffff;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 0;
  border-radius: 0;
}

/* .back-image {
  width: 23px;
  height: 23px;
} */

.header-menu {
  padding: 8px 0;
}

.header-menu ::v-deep .ant-dropdown-menu-item {
  padding: 6px 27px 6px 16px;
}

.header-menu .ant-dropdown-menu-item > .anticon:first-child,
.header-menu .ant-dropdown-menu-item > a > .anticon:first-child {
  font-size: 15px;
  vertical-align: -0.2em;
}

.preview-header-title,
.header-draft-generate {
  box-sizing: border-box;
}

.preview-header-title {
  font-size: 16px;
  font-weight: 400;
  color: #333;
  max-width: 375px;
  width: 45%;
  padding-left: 19px;
  /*padding-right: 106px;*/
  outline: none;
  border: none;
  height: 50px;
  margin-left: -8px;
  margin-right: 12px;
  transition: 0.3s;
  border-radius: 0;
  background: #fff;
}

.seo-menu {
  position: absolute;
  left: 263px;
  top: 45px;
  background: #fff;
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.1), 0 0 6px rgba(0, 0, 0, 0.15);
  overflow: hidden;
}

.seo-item,
.seo-menu-title {
  display: flex;
  align-items: center;
  width: 520px;
  min-height: 37px;
  background: rgba(247, 248, 249, 1);
  border-bottom: 1px solid #e7e8e9;
  font-weight: 400;
}

.seo-item {
  cursor: pointer;
  background: #ffffff;
  padding: 4px 0;
}

.seo-item:hover {
  background: #e7e8e9;
}

.seo-menu__spin {
  margin-bottom: -1px;
}

.seo-title {
  width: 334px;
  margin: 0 28px;
  word-wrap: break-word;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  overflow: hidden;
  text-overflow: ellipsis;
}

.red {
  color: red;
  display: inline;
}

.seo-search,
.seo-hard {
  display: flex;
  justify-content: flex-end;
}

.seo-search {
  width: 52px;
  margin-right: 32px;
}

.seo-hard {
  width: 67px;
  margin-right: 27px;
}
.pen {
  pointer-events: none;
  font-size: 16px;
  margin-right: 6px;
}

.preview-header-title::placeholder {
  opacity: 0.5;
  color: #666;
}

.preview-header-title:focus,
.preview-header-title:hover {
  background: #f1f2f3;
}

.header-button-group-wrap {
  flex: 1;
}

.header-button-group {
  display: flex;
  align-items: center;
  font-size: 14px;
  margin-left: 280px;
  position: relative;
}

.header-button-group__divider {
  height: 14px;
  border-right: 1px solid rgba(0, 0, 0, 0.1);
  margin: 0 15px 0 4px;
}

.header-button-group .icon {
  font-size: 14px;
  border: 0;
  border-radius: 0;
  padding: 5px;
  background: transparent;
  outline: 0;
  cursor: pointer;
  color: rgba(0, 0, 0, 0.75);
  line-height: 16px;
  margin-right: 11px;
}

.header-button-group__text {
  padding: 2px;
  font-size: 14px;
  line-height: 16px;
  margin-right: 11px;
}

.header-button-group .icon:hover,
.header-button-group .icon:focus {
  color: #007eff;
}

.header-button-group .icon:disabled {
  cursor: default;
  color: rgba(0, 0, 0, 0.15);
}

.header-total-duration {
  padding-right: 27px;
  /* margin-right: 11px; */
  /* box-shadow: 4px 0 0 -3px rgba(0, 0, 0, 0.1); */
}

.header-draft-generate {
  height: 100%;
}

.header-draft-generate .icon {
  opacity: 0.6;
  margin-right: 16px;
  cursor: pointer;
  overflow: hidden;
  padding: 3px;
  outline: 0;
  font-size: 16px;
}

.header-draft-generate .icon img {
  display: block;
}

.header-draft-generate .fill-icon img {
  filter: drop-shadow(#3e3e3e 0 20px);
  position: relative;
  top: -20px;
}

.header-draft-generate .fill-icon,
.header-draft-generate .icon:hover {
  opacity: 1;
}

.header-button {
  cursor: pointer;
  height: 28px;
  background: transparent;
  border: 1px solid;
  border-radius: 99px;
  justify-content: center;
  font-size: 14px;
  box-sizing: border-box;
  padding: 0 14px;
  margin-right: 16px;
  outline: 0;
  transition: 0.3s;
}

.header-button:disabled {
  opacity: 0.3;
  pointer-events: none;
}

.header-button .icon {
  margin: 0 6px -2px 0;
  font-size: 14px;
  opacity: 1;
}

.helps {
  text-decoration: none;
  margin-right: 27px;
}

.save-button {
  font-weight: 400;
  color: #007eff;
}

.save-button:hover,
.save-button:focus {
  background-color: #f1f2f3;
  /* box-shadow: 0 3px 10px rgba(0, 0, 0, 0.08), 0 1px 1px 1px rgba(0, 0, 0, 0.04); */
}

.save-button:active {
  box-shadow: 0 0 1px transparent, 0 0 2px rgba(0, 0, 0, 0.08),
    inset 0 2px 6px rgba(0, 0, 0, 0.1);
}
/*
.save-button .icon {
  font-size: 14px;
} */

.generate-button {
  background: #34aa44;
  color: #fff;
  /* height: 30px; */
  /* border-radius: 0; */
  padding: 0 16px;
  border: 0;
  /* margin-right: -20px; */
}

.generate-button:hover,
.generate-button:focus {
  background-color: #56b860;
}

.generate-button:active {
  background-color: #228533;
}

.advanced-settings-row {
  margin-bottom: 16px;
}

.advanced-settings-select {
  width: 80px;
  overflow: hidden;
  display: block;
}

.advanced-settings-select ::v-deep .ant-select-selection {
  height: 28px;
  border-radius: 2px;
}

.advanced-settings-select ::v-deep .ant-select-selection__rendered {
  line-height: 26px;
}

.advanced-settings-select.ant-select-disabled {
  opacity: 0.4;
}
</style>

<style scoped>
.seo-title {
  flex-grow: 1;
}

.seo-hard,
.seo-search {
  display: none;
}
</style>
